import { useMemo } from 'react';
import { orderMembers } from '@platform/core/lib/memberOrder';
import type { IWorkspaceMember } from '@platform/core/types';
import { useMeQuery, useMembersQuery } from '@platform/state/api';

const NONE: IWorkspaceMember[] = [];

/**
 * Учасники воркспейсу для фільтрів і пікерів людей у порядку прототипу v4: поточний користувач першим, далі — порядок членства з API
 * (orderMembers). `skip` — без запиту (поле не про людей).
 */
export function useWorkspaceMembers(ws: string, skip = false): IWorkspaceMember[] {
  const { data: members } = useMembersQuery(ws, { skip: skip || !ws });
  const { data: me } = useMeQuery();
  return useMemo(() => orderMembers(members ?? NONE, me?.id), [members, me?.id]);
}
